import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, TemplateRef } from '@angular/core';
import { SkeletonLoaderComponent, SkeletonPreset } from '../skeleton-loader/skeleton-loader.component';
import { SectionEmptyComponent, SectionEmptyPreset } from '../section-empty/section-empty.component';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'cm-section-data',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, SkeletonLoaderComponent, SectionEmptyComponent, CardComponent],
  templateUrl: './section-data.component.html',
  styleUrl: './section-data.component.less',
})
export class SectionDataComponent {
  public readonly loading = input<boolean>(false);
  public readonly empty = input<boolean>(false);
  public readonly error = input<boolean>(false);
  public readonly skeletonLoaderPreset = input<SkeletonPreset>('section');

  /**
   * Optional custom loading template. When provided, it is rendered while `loading` is true instead
   * of the built-in skeleton preset — for pages that need a bespoke loading skeleton.
   */
  public readonly loadingTemplate = input<TemplateRef<unknown> | null>(null);

  public readonly emptyPreset = input<SectionEmptyPreset>('block');
  public readonly emptyIcon = input<string>('description');
  public readonly emptyTitle = input<string>('No data available');
  public readonly emptySubtitle = input<string>('');
  public readonly emptyButtonLabel = input<string>('');
  public readonly emptyButtonIcon = input<string>('');
  public readonly emptyButtonLoading = input<boolean>(false);
  public readonly emptyUseCardContainer = input<boolean>(false);

  public readonly errorTitle = input<string>('Something went wrong');
  public readonly errorSubtitle = input<string>('Please try again later');
  public readonly errorButtonLabel = input<string>('Refresh');
  public readonly errorIcon = input<string>('error');
  public readonly errorUseCardContainer = input<boolean>(false);

  public readonly emptyAction = output<void>();
  public readonly errorRefreshAction = output<void>();

  public onEmptyAction(): void {
    this.emptyAction.emit();
  }

  public onErrorRefreshAction(): void {
    this.errorRefreshAction.emit();
  }
}
